import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';

import { useUser } from 'applications/GSP/shared/hooks/user';

export const useGreetingMessages = () => {
  const { t } = useTranslation();
  const { firstName } = useUser() || {};

  return useMemo(
    () => [
      {
        id: t('GSP.pages.parentHelper.chat.body.greeting', {
          name: firstName,
        }).slice(0, 5),
        answer: t('GSP.pages.parentHelper.chat.body.greeting', {
          name: firstName,
        }),
        withoutAvatar: true,
        withoutFeedback: true,
      },
      {
        id: t('GSP.pages.parentHelper.chat.body.howCanIHelp').slice(0, 5),
        answer: t('GSP.pages.parentHelper.chat.body.howCanIHelp'),
        withoutFeedback: true,
      },
    ],
    [t, firstName],
  );
};
